import { VerifyCodeScreenNavigationProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import VerifyCode from "./verify-code-screen"
import { PageRoot } from "~screens/page-root"


const VerifyCodeScreen: React.FC<VerifyCodeScreenNavigationProps> = ({ route }) => {
  const theme = useTheme()
  return (
    <PageRoot $background={theme.colors.primary}>
      <VerifyCode route={route} />
    </PageRoot>
  )
}

export default VerifyCodeScreen
